import model from 'modules/buildingLevel1/buildingLevel1Model';

const { fields } = model;

export default [
  fields.name,
  fields.level2,
];
